import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const CommercePayment = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_, hasScope) => hasScope('commerce-payments-access'),
  objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
  referenceObjectType: 'COMMERCE_PAYMENT_PROPERTIES'
});
export default CommercePayment;